class PriceRangeSlider extends HTMLElement {
  constructor() {
    super();
    this.sliderMax = Number(this.dataset.max) || 300;

    this.minHandle = this.querySelector('.price-range-slider__handle--min');
    this.maxHandle = this.querySelector('.price-range-slider__handle--max');
    this.fill = this.querySelector('.price-range-slider__fill');

    const wrapper = this.closest('price-range') || this.parentElement;
    this.minValueLabel = wrapper ? wrapper.querySelector('.price-range-slider__value--min') : null;
    this.maxValueLabel = wrapper ? wrapper.querySelector('.price-range-slider__value--max') : null;

    const textInputs = wrapper ? wrapper.querySelectorAll('input[type="text"]') : [];
    this.minTextInput = textInputs[0] || null;
    this.maxTextInput = textInputs[1] || null;

    if (!this.minHandle || !this.maxHandle) return;

    this.minHandle.addEventListener('input', this.onDrag.bind(this));
    this.maxHandle.addEventListener('input', this.onDrag.bind(this));
    this.minHandle.addEventListener('change', this.onCommit.bind(this));
    this.maxHandle.addEventListener('change', this.onCommit.bind(this));

    this.render();
  }

  onDrag(event) {
    const min = Number(this.minHandle.value);
    const max = Number(this.maxHandle.value);

    if (min > max) {
      if (event.currentTarget === this.minHandle) {
        this.minHandle.value = max;
      } else {
        this.maxHandle.value = min;
      }
    }

    this.render();
  }

  onCommit() {
    const min = Number(this.minHandle.value);
    const max = Number(this.maxHandle.value);

    if (this.minTextInput) {
      this.minTextInput.value = min > 0 ? min : '';
      this.minTextInput.dispatchEvent(new Event('change', { bubbles: true }));
      this.minTextInput.dispatchEvent(new Event('input', { bubbles: true }));
    }

    if (this.maxTextInput) {
      this.maxTextInput.value = max < this.sliderMax ? max : '';
      this.maxTextInput.dispatchEvent(new Event('change', { bubbles: true }));
      this.maxTextInput.dispatchEvent(new Event('input', { bubbles: true }));
    }
  }

  render() {
    const min = Number(this.minHandle.value);
    const max = Number(this.maxHandle.value);
    const minPercent = (min / this.sliderMax) * 100;
    const maxPercent = (max / this.sliderMax) * 100;

    if (this.fill) {
      this.fill.style.left = `${minPercent}%`;
      this.fill.style.right = `${100 - maxPercent}%`;
    }

    if (this.minValueLabel) this.minValueLabel.textContent = this.formatMoney(min);
    if (this.maxValueLabel) this.maxValueLabel.textContent = this.formatMoney(max);
  }

  formatMoney(value) {
    const currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'es-ES', {
        style: 'currency',
        currency,
      }).format(value);
    } catch (error) {
      return `€${value.toFixed(2)}`;
    }
  }
}

if (!customElements.get('price-range-slider')) {
  customElements.define('price-range-slider', PriceRangeSlider);
}
